import { Component, OnInit } from '@angular/core';

import { ConcessionStatus } from '../constants/app.constants';
import { ConcessionData, UserInfo } from '../domains/common.domain';
import { LicenseService } from './license.service';
import { FileService } from '../services/file.service';
import { ErrorService } from '../services/error/error.service';
import { ConfirmationService } from 'primeng/api';
import { TechnicianResponseData } from '../employee-overview/employee-overview.domain';
import { CommunicationService } from '../services/communication.service';
import { CommonService } from '../services/common.service';
import { UserService } from '../services/user.service';
import { DestroyableComponent } from '../common/destroyable.component';
import { switchMap } from 'rxjs/operators';

@Component({
  providers: [ConfirmationService, LicenseService],
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.scss'],
})
export class LicenseComponent extends DestroyableComponent implements OnInit {
  public concession: ConcessionData;
  isLoading: boolean;
  public status: {
    [key: string]: string;
  } = ConcessionStatus;
  public isDocumentUploaded: boolean = true;

  constructor(
    private fileService: FileService,
    private licenseService: LicenseService,
    private errorService: ErrorService,
    private confirmationService: ConfirmationService,
    private communicationService: CommunicationService,
    private commonService: CommonService,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.preventLeak(this.licenseService.getConcession()).subscribe(
      concession => {
        this.concession = concession;
        if (this.concession.is_document_uploaded === 'false') {
          this.isDocumentUploaded = false;
        }
      },
      error => this.errorService.throwErrorIfFailure(error, true),
      () => (this.isLoading = false)
    );
  }

  downloadLicense(): void {
    this.preventLeak(this.licenseService.downloadLicense()).subscribe(
      response => this.fileService.downloadZipDocument(response),
      error => this.errorService.throwErrorIfFailure(error, true)
    );
  }

  renewLicense(): void {
    this.confirmationService.confirm({
      accept: () => this.updateLicense(),
      reject: () => this.confirmationService.close(),
    });
  }

  private updateLicense() {
    this.isLoading = true;

    this.preventLeak(this.licenseService.updateLicense())
      .pipe(
        switchMap(() =>
          this.communicationService.getData<TechnicianResponseData>(`technician?technician_id=${this.concession.technician_id}`)
        )
      )
      .subscribe(
        technicianDataResponse => {
          this.errorService.throwErrorIfFailure(technicianDataResponse, true);
          const technicianData = (technicianDataResponse.technician && technicianDataResponse.technician[0]) || null;
          this.commonService.technicianData = technicianData;

          const userData: UserInfo = {
            status: technicianData && technicianData.status,
            technician_id: this.concession.technician_id,
            user_email: technicianData && technicianData.email,
            role: technicianData && technicianData.role,
          };

          this.userService.setUserData(userData, userData.role, userData.status);
          window.location.reload();
        },
        error => {
          this.errorService.throwErrorIfFailure(error, true);
        },
        () => (this.isLoading = false)
      );
  }
}
